import { useEffect, useCallback, useState, useRef } from 'react';
import PubSub from 'pubsub-js';
import { selectInfoWarningPopupMessage, selectShowInfoWarningPopup } from '../redux/slicers/admin/curatorUnityObjectSlicer';
import { getAppState } from '../redux/store';

export const useContextMenu = ({ selector, element, unityEvent, disabled }) => {
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [show, setShow] = useState(false);
  const lastMouseDownValues = useRef({});
  const isContextEvent = useRef(false);

  useEffect(() => {
    let timerId;
    const RightClickCallbackReceiverCallback = (_) => {
      // hide right click menu if alignment info is open (we are selecting reference object)
      const showPopup = selectShowInfoWarningPopup(getAppState());
      const popupMessage = selectInfoWarningPopupMessage(getAppState());
      timerId && clearTimeout(timerId);
      timerId = setTimeout(() => {
          if (isContextEvent.current && (!showPopup || !popupMessage?.includes('alignment'))) {
            setShow(true);
            isContextEvent.current = false;
          }
        }, 150);
    };
    PubSub.subscribe(unityEvent, RightClickCallbackReceiverCallback);
    return () => {
      PubSub.unsubscribe(RightClickCallbackReceiverCallback);
      timerId && clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    if (disabled) {
      setShow(false);
    }
  }, [disabled]);

  const handleContextMenu = useCallback(
    (event) => {
      if (disabled) {
        return;
      }
      event.preventDefault();
      setShow(false);
      isContextEvent.current = true;
      // added 10px to solve issue DEV-29241 as per unity team
      setAnchorPoint({ x: (event.pageX + 10), y: (event.pageY + 10) });
    },
    [setShow, setAnchorPoint, disabled]
  );

  const handleMouseDown = (e) => {
    isContextEvent.current = false;
    lastMouseDownValues.current = {
      startX: e.clientX,
      startY: e.clientY,
    };
    if (show) {
      setShow(false);
    }
  };

  const handleMouseUp = (e) => {
    // hide right click menu if alignment info is open (we are selecting reference object)
    const showPopup = selectShowInfoWarningPopup(getAppState());
    const popupMessage = selectInfoWarningPopupMessage(getAppState());
    setTimeout(async () => {
      const { startX, startY } = lastMouseDownValues.current;
      const diffY = startY - e.clientY;
      const diffX = startX - e.clientX;
      const threshold = 10;
      const sameCoordinates = Math.abs(diffY) < threshold && Math.abs(diffX) < threshold;
      if (isContextEvent.current && sameCoordinates && (!showPopup || !popupMessage?.includes('alignment'))) {
        // await waitForEventOnce(UnityEvent.RightClickCallbackReceiver); // TODO: check if doBeforeContextMenuShow work correctly and then remove this line
        setShow(true);
      }
      isContextEvent.current = false;
    });
  };

  useEffect(() => {
    const el = element 
      ? element 
      : selector 
        ? document.querySelector(selector) 
        : document;
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    el.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      el.removeEventListener('contextmenu', handleContextMenu);
    };
  }, [show, handleContextMenu]);
  return { anchorPoint, show };
};
